import { sortSizes } from "@core/utils";
import { metaAdapter } from "@meta/index"
import type { EventContext, InitialConfig } from "@src/types";

import { HeadlessPdpZone } from "./zones/PDP"
import { HeadlessPdcZone } from "./zones/PDC"
import type {
  HeadlessItemsPDCContext,
  HeadlessBrandPDCContext,
  HeadlessLineItemsPDCContext,
  HeadlessBrandContext,
  HeadlessLineItemsContext,
  HeadlessValueContext,
  HeadlessAvailableGridContext,
  HeadlessItemsContext,
  HeadlessItemsPDPContext, 
  HeadlessLineItemsPDPContext,
} from "./types"

export const headlessAdapter = {
  ...metaAdapter, // global adapters

  brand: (context: HeadlessBrandContext, config: InitialConfig) => {
    if (context.zone === 'PDP') {
      return HeadlessPdpZone.brand(context as HeadlessLineItemsPDPContext, config)
    }

    if (context.zone === 'PDC') {
      return HeadlessPdcZone.brand(context as HeadlessBrandPDCContext, config)
    }

    return null
  },

  line_items: (context: HeadlessLineItemsContext): string | null => {
    if (context.zone === 'PDP') {
      return HeadlessPdpZone.line_items(context as HeadlessLineItemsPDPContext)
    }

    if (context.zone === 'PDC') {
      return HeadlessPdcZone.line_items(context as HeadlessLineItemsPDCContext)
    }

    return null
  },

  value: (context: HeadlessValueContext): number | null => {
    if (context.zone === 'PDP') {
      return HeadlessPdpZone.value(context as HeadlessItemsPDPContext)
    }

    if (context.zone === 'PDC') {
      return HeadlessPdcZone.value(context as HeadlessItemsPDCContext)
    }

    return null;
  },

  items: (context: HeadlessItemsContext) => {
    if (context.zone === 'PDP') {
      return HeadlessPdpZone.items(context as HeadlessItemsPDPContext)
    }

    if (context.zone === 'PDC') {
      return HeadlessPdcZone.items(context as HeadlessItemsPDCContext)
    }
  },

  // param used only in one Zone, the PDP; no need condition
  available_grid: (context: HeadlessAvailableGridContext): string | null => {
    if (context?.available_grid) return context.available_grid

    if (context?.products) {
      const sizes = context.products.flatMap(p => p.items.map(i => i.Tamanho[0]))
      const result = sortSizes(sizes).join(',')
      return result || null
    }

    return null;
  },
}
